export default "__VITE_ASSET__BcRXcG4y__"